<template>
      <div class="my-home-content4">
        <h2>服务全国客户的行业案例</h2>
        <span class="span14">Industry cases serving customers across the country</span>
        <router-link :to="{path:'successCase'}">
          <span class="span24" @click="go()">查看更多客户案例></span>
        </router-link>
        <div>
          <Row>
              <Col span="2"></Col>
              <Col span="10" style="padding-left: 0.5rem;margin-bottom: 0.2rem;padding-right: 0.1rem;">
                  <router-link :to="{path:'successDetails',query:{num:'0'}}">
                    <div class="my-content4">
                      <div class="content4-img">
                        <img src="../../assets/img/ntby.png" width="100%">
                      </div>
                      <h3>东阳光宜都工业园区智慧园区管理平台</h3>
                      <div class="my-content4-span">
                        <span>以平台建设的模式对园区内外基础数据、业务资源进行整合和统一管理，建立园区数据中心，对园区管理数据进行抽取、清洗和转换，通过平台与信息化设备和园区各管理子系统的对接，实现业务数据全链路采集、信息化设备统一监管。建设园区车辆通行管理应用等</span>
                      </div>
                    </div>
                  </router-link>

                 <div class="my-content4-img">
                   <div class="trademark">
                     <img src="../../assets/img/dyg.png" width="100%"  class="img1"/>
                   </div>
                   <div class="trademark">
                     <img src="../../assets/img/hbyh.png" width="100%"  class="img1"/>
                   </div>
<!--                     <img src="../../assets/img/tx1.png" width="48%" height="100rem" class="img1"/>
                     <img src="../../assets/img/tx2.png" width="48%" height="100rem" class="img2"/> -->
                 </div>
              </Col>
              <Col span="10" style="padding-right: 0.5rem; padding-left: 0.1rem;">
                <router-link :to="{path:'successDetails',query:{num:'1'}}">
                  
                  <div class="my-content4">
                    <div class="content4-img">
                      <img src="../../assets/img/ntby3.png" width="100%" class="ntby3">
                    </div>
                    <h3>金鹰重型工程机械股份有限公司综合管理平台 </h3>
                      <div class="my-content4-span">
                        <span>基于IT综合运维管理平台在金鹰重工的部署，及时掌控网络设备、服务器、应用系统及机房的可用性、可靠性和稳定性；及时、快速处理突发的故障和业务平台应用服务问题。更好的管理IT硬件设备及软件系统；提供一个高可用性、高可靠性和高稳定性的网络；快速处理突发的故障，做到防患于未然。从而实现人工排查耗时耗力运维现状到综合资源智能监控、快速响应的跨越。</span>
                      </div>
                  </div>
                </router-link>
                  <div class="my-content4-img">
                    <div class="trademark">
                      <img src="../../assets/img/ycscsd.png" width="100%"  class="img1"/>
                    </div>
                    <div class="trademark">
                      <img src="../../assets/img/jyC.png" width="100%"  class="img1 imgjy" />
                    </div>
                    
                   </div>
              </Col>
              <Col span="2"></Col>
          </Row>
          <a href="#fivePage">
            <div>
              <Arrow/>
            </div>

          </a>
          <a name="fivePage"></a>
        </div>
      </div>


</template>

<script>
    import Arrow from '@/pages/components/Arrow'
    export default {
      name: 'HomeContent4',
      components:{Arrow},
      methods:{
        go(){
          this.resetSetItem('index','5');
        }
      }
    }
</script>

<style>
  .my-home-content4{
    text-align: center;
    padding-bottom: 0.75rem;
  }
  .my-home-content4 h2{
    font-size: 0.25rem;
    margin-bottom: 0.25rem;
    letter-spacing:0.02rem;
    margin-top: -0.5rem;
  font-family: Nowar-CC-Warcraft-CN-Bold;
	font-weight: bold;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #333333;
  }
  .span14{
    	font-family: SourceHanSansCN-Light;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #666666;
  }
  .span24{
    color: #5ac1ff;
    font-family: SourceHanSansCN-Light;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #009bff;
  cursor: pointer;
  }
  .my-content4{
    /* padding-right: 0.21rem; */
    /* margin-right: 0.6rem; */
    margin-top: 0.5rem;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-image: url(../../assets/img/home-content-bj2.png);
    cursor: pointer;
  }
  .content4-img{
    width: 100%;
    height: 4.5rem;
  }
  .my-content4-img{
    margin-top: 0.2rem;
  }

 .ntby3{
    border:2px solid white;
    border-radius: 8px 8px 0 0;
  }
  .my-content4 h3{
    margin-top: 0.1rem;
    margin-bottom: 0.1rem;

    	font-family: SourceHanSansCN-Medium;
	font-weight: bold;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #253954;
  }
  .my-content4 span{
    margin-top: 0.2rem;
    font-family: SourceHanSansCN-Light;
   	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #253554;
  overflow: hidden;
			    text-overflow: ellipsis;
			    display: -webkit-box;
			    -webkit-line-clamp: 3;
			    -webkit-box-orient: vertical;

  }
 .img1{
    float: left;
  }

  .imgjy{
    margin-top:-15px;
    width: 95%;
  }

  .img2{
    float: right;
    padding-right: 20px;
  }
  .my-content4-span{
    padding: 0 0.3rem;
    text-align: left;
/*    margin-bottom: 0.5rem; */
    padding-bottom: 0.3rem;
  }
  .trademark{
    padding: 0.4rem;
    width: 46%;
    margin-right: 2%;
    float: left;
    width: 48%;
    border: 2px solid white;
    height: 1.1rem;
    cursor: pointer;
    /* border-style: solid; */
    box-shadow: 0 0 5px #eaeff5 inset;
  }
    .my-content5 .ivu-carousel-arrow.left {
      display: none;
    }
    .my-content5 .ivu-carousel-arrow.right{
      display: none;
    }
/*    .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item,.ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu{
      color: #FFFFFF;
    } */

</style>



// WEBPACK FOOTER //
// src/pages/home-content/HomeContent4.vue